export default "__VITE_ASSET__CcPgAlak__"